import { Directive, Input, OnInit } from '@angular/core';
// Service
import { RulesChangeService } from '../services/rules-change.service';
// Model
import { RuleItemDirectiveDataModel } from '../models/rule-item-directive.model';

@Directive({
	selector: '[cvInvisionRuleItemDirective]'
})
export class RuleItemDirectiveDirective implements OnInit {
	@Input() data: RuleItemDirectiveDataModel;

	constructor(private rulesChangeService: RulesChangeService) { }

	ngOnInit(): void {
		if (this.data.id) {
			this.rulesChangeService.addItem(
				this.data.id,
				this.data
			);
		}
	}

}
